import { Tag } from '@/components/Insights/Tags/components/Tag';
import { useEffect, useState } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { DEFAULT_SEARCH_PARAMS } from '@/constants/insights';
import clsx from 'clsx';
import { addTagsToSearchParams, removeTagsToSearchParams } from '@/helpers/searchParamsHelpers';

interface IProps {
  tags: string[];
  tagsWrapperClass?: string;
  tagsMap?: any;
}

export const Tags = ({ tags, tagsWrapperClass, tagsMap }: IProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [unselectedTags, setUnselectedTags] = useState<string[] | []>([...tags]);
  const [selectedTags, setSelectedTags] = useState<string[] | []>([]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(searchParams);
    const tagsFromSearchParams = urlSearchParams.get(DEFAULT_SEARCH_PARAMS.tags);

    if (tagsFromSearchParams) {
      setSelectedTags(tagsFromSearchParams.split(','));
      setUnselectedTags(tags.filter((item) => !tagsFromSearchParams.split(',').includes(item)));
    } else {
      setSelectedTags([]);
      setUnselectedTags(tags);
    }
  }, [searchParams, tags]);

  return (
    <div
      data-testid="tags-wrapper"
      className="overflow-hidden flex flex-col"
    >
      <div
        data-testid="unselected-tags"
        className={clsx('flex flex-wrap', {
          [`${tagsWrapperClass}`]: tagsWrapperClass,
        })}
      >
        {unselectedTags.map((tag) => (
          <Tag
            tagsMap={tagsMap}
            key={tag}
            tagName={tag}
            handleClick={() => addTagsToSearchParams(tag, router, pathname, searchParams)}
          />
        ))}
      </div>
      {Boolean(selectedTags.length) && (
        <div
          data-testid="selected-tags"
          className={clsx('flex flex-wrap', {
            ['pt-[40px]']: unselectedTags.length,
            ['pt-0']: !unselectedTags.length,
            [`${tagsWrapperClass}`]: tagsWrapperClass,
          })}
        >
          {selectedTags.map((tag) => (
            <Tag
              tagsMap={tagsMap}
              key={tag}
              tagName={tag}
              withCrossIcon
              isActive
              handleClick={() => removeTagsToSearchParams(tag, router, pathname, searchParams)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
